/*@ngInject*/
const UINextRequiredFieldFinderDirective = function ($rootScope, $timeout, $q, coreConstant, fieldType, formComponentUtil, formRepository, formViewerConstant, formViewerModel, formViewerUtil, formatUtil, localization, umsLog, dataSetUtil, formSummaryGridUtil, coreMediator, dataSetType) {

    let linkFunction = function ($scope, $elm) {

        localization.setupLocale('fieldFinder', require('./uiNextRequiredFieldFinder.i18n.json'));

        const timeoutList = [];

        let nextRequiredFieldIndex = 0,
            eligibleRequiredFieldList = [];

        function resetEligibleRequiredFieldList() {
            let fieldStructureList = _.clone(formViewerModel.getFieldMap($scope.formId).values());

            eligibleRequiredFieldList = [];

            const promises = [];
            const tempEligibleRequiredFieldList = [];

            // To properly generate the eligibleRequiredFieldList, the following steps are taken:
            // 1.) Iterate through all field structures in the current form, including supplemental forms
            // 2.) If the field structure is not hidden and has no value or is invalid proceed, otherwise skip
            // 3.) If the field structure is not a form summary grid or a row repeater, and is required, add it to the temporary list
            // 4.) If the field structure if a form summary grid, we have to make some server calls to determine the current items in the form summary grid.
            //     If there are any required items in the form summary grid, add it to the temporary list
            // 5.) Once everything has finished ($q.all) re-iterate through the field structures in the current form, including supplemental forms,
            //     and if the field structure appears in the temporary list, add it to the actual list. This is done to maintain the required field ordering because of the async
            //     calls needed to the server because of form summary grids.

            _.each(fieldStructureList, function (fieldStructure) {
                const hasValue = fieldStructure.dynamicProperties.hasValue;
                const isValid = fieldStructure.dynamicProperties.isValid;
                const isHidden = fieldStructure.dynamicProperties.hidden;
                const isFormSummaryGrid = fieldStructure.uiField.fieldTemplate.type === fieldType.FORM_SUMMARY_GRID;
                const isNotRowRepeater = fieldStructure.uiField.fieldTemplate.type !== fieldType.ROWREPEATER;
                const isFieldInsideRowRepeater = fieldStructure.rowRepeaterId;
                const isOptionallyRequired = fieldStructure.dynamicProperties.isOptionallyRequired;
                const isRequired = isFieldInsideRowRepeater && isOptionallyRequired ? fieldStructure.dynamicProperties.isColumnRequired : fieldStructure.dynamicProperties.isRequired;

                if (!isHidden && !(hasValue && isValid)) {
                    if (isFormSummaryGrid) {
                        const dataSetName = fieldStructure.uiField.fieldTemplate.dataSetName;
                        if (!_.isNil(dataSetName)) {
                            const promise = coreMediator.getCachedDataSetByName(dataSetName).then(function (dataSet) {
                                if (dataSet.type !== dataSetType.STATIC) {
                                    const dataSetParams = dataSetUtil.getDataSetParamsByFieldStructure(dataSet, fieldStructure);
                                    const formId = fieldStructure.parentForm.id;

                                    return dataSetUtil.getDataItems(dataSetParams, formId).then(function (dataSetItems) {
                                        const formSummaryGridItems = formSummaryGridUtil.processFormSummaryGridItems(dataSetItems);
                                        _.each(formSummaryGridItems, function (formSummaryGridItem) {
                                            if (formSummaryGridItem.name.requiredCount.value > 0) {
                                                tempEligibleRequiredFieldList.push(fieldStructure.fieldStructureId);
                                                return false;
                                            }
                                        });
                                    });
                                }
                            });
                            promises.push(promise);
                        }
                    } else if (isNotRowRepeater && isRequired) {
                        // If this is a required and blank or invalid field then we've found an eligible required field, so add it.
                        tempEligibleRequiredFieldList.push(fieldStructure.fieldStructureId);
                    }
                }
            });

            return $q.all(promises).then(function () {
                _.each(fieldStructureList, function (fieldStructure) {
                    if (_.includes(tempEligibleRequiredFieldList, fieldStructure.fieldStructureId)) {
                        eligibleRequiredFieldList.push(fieldStructure);
                    }
                });
            });
        }

        function findNextRequiredField() {
            const formStructure = formViewerModel.getFormStructure($scope.formId);

            if (formStructure && formStructure.formModel && formStructure.formName) {
                resetEligibleRequiredFieldList().then(function () {
                    if (nextRequiredFieldIndex >= eligibleRequiredFieldList.length) {
                        nextRequiredFieldIndex = 0;
                    }

                    let fieldStructure = eligibleRequiredFieldList[nextRequiredFieldIndex++];
                    if (!fieldStructure) {
                        formRepository.resetRequiredFieldCountByFormId($scope.formId).then((didTotalRequiredFieldCountChange) => {
                            if (didTotalRequiredFieldCountChange) {
                                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, i18n.t('fieldFinder|uiNextRequiredFieldFinder.requiredCountRecalculatedNotification'));
                            } else {
                                umsLog.warn('The next required field could not be found, but a reset of the required field count did not produce a change!');
                            }
                        });
                    } else {
                        triggerNotification(fieldStructure);
                    }
                });
            } else {
                timeoutList.push($timeout(function () {
                    findNextRequiredField();
                }));
            }
        }

        function triggerNotification(fieldStructure) {

            function handleScroll(containerElement, targetElement) {
                if (containerElement.length && targetElement.length) {
                    const formViewerContainer = containerElement.parent();
                    const containerOffsetTop = containerElement.offset().top;
                    const elementOffsetTop = targetElement.offset().top;
                    const currentScroll = containerElement.scrollTop();
                    const topMargin = 75;

                    formViewerContainer.animate({
                        scrollTop: (currentScroll + elementOffsetTop) - containerOffsetTop - topMargin
                    }, 300);
                }
            }

            function handleDropdown(dropdownElement, className) {
                timeoutList.push($timeout(function () {
                    const dropdownButton = dropdownElement.find(className);
                    dropdownButton.focus();
                    dropdownButton.trigger('click');
                }, 500));
            }

            if (!fieldStructure) {
                return;
            }

            const type = fieldStructure.uiField.fieldTemplate.type;

            if (type === fieldType.FORM_SUMMARY_GRID) {
                $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_FORM_SUMMARY_GRID, fieldStructure.fieldStructureId);
            } else {
                let selector = '[form-id="' + fieldStructure.rootFormId + '"] .' + formatUtil.formatAsSelector(fieldStructure.parentForm.formTemplateUniqueName);

                if (fieldStructure.rowInstanceId) {
                    selector += ' .row' + fieldStructure.rowNumber;
                }

                selector += ' .formFieldComponent-' + formatUtil.formatAsSelector(fieldStructure.uiField.fieldTemplate.variableName);

                let fieldElement = $(selector);

                if (fieldElement) {
                    handleScroll($($elm), fieldElement);
                }

                const isDropdown = fieldElement.hasClass('umDropdownContainer');
                const isClassCode  = fieldElement.hasClass('classCodeStateSelect');
                const isCalender = fieldElement.hasClass('componentCalendarContainer');
                const isRadio = fieldElement.is(':radio') || type === fieldType.RADIO_BUTTON_GROUP || type === fieldType.YES_NO;
                const isCheckbox = fieldElement.is(':checkbox') || type === fieldType.CHECK_BOX || type === fieldType.CHECK_BOX_GROUP;

                if (isDropdown) {
                    handleDropdown(fieldElement, '.match');
                    fieldElement = fieldElement.find('.match');
                } else if (isClassCode) {
                    handleDropdown(fieldElement, '.ui-select-match');
                    fieldElement = fieldElement.find('.ui-select-match');
                } else if (isRadio || isCheckbox) {
                    fieldElement = $(fieldElement[0]).closest('.fieldListComponent');
                    let focusFieldElement = fieldElement.find('input')
                    timeoutList.push($timeout(function () {
                        focusFieldElement.focus();
                    }, 500));
                } else if (isCalender) {
                    fieldElement = fieldElement.find('input');
                    timeoutList.push($timeout(function () {
                        fieldElement.focus();
                    }, 500));
                } else {
                    timeoutList.push($timeout(function () {
                        fieldElement.click();
                        fieldElement.focus();
                    }, 500));
                }

                fieldElement.addClass('animateFieldNotification');
                fieldElement.addClass('nextRequiredFieldNotification');

                timeoutList.push($timeout(function () {
                    removeNotification(fieldElement);
                }, 3000));
            }
        }

        function removeNotification(fieldElement) {
            fieldElement.removeClass('nextRequiredFieldNotification');

            timeoutList.push($timeout(function () {
                removeTransition(fieldElement);
            }, 500));
        }

        function removeTransition(fieldElement) {
            fieldElement.removeClass('animateFieldNotification');
        }

        function configure() {
            $scope.$on(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, function (event, formId) {
                if (parseInt($scope.formId) === parseInt(formId)) {
                    findNextRequiredField();
                }
            });
        }

        if (!$scope.supplemental) {
            configure();
        }

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiNextRequiredFieldFinder', UINextRequiredFieldFinderDirective);
